// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/util/sanitizer.js
// Demo templates need formatting elements only. Programmatic DOM templates can
// also return a Node (for example a header with its own button listeners).
export function setTemplate(element, content) {
  if (content instanceof Node) return element.replaceChildren(content)
  const template = document.createElement("template")
  template.innerHTML = String(content)
  template.content.querySelectorAll("*").forEach((child) => {
    if (!["SPAN", "SMALL", "STRONG", "B", "EM", "MARK", "DIV", "P", "BR"].includes(child.tagName)) {
      child.remove()
      return
    }
    [...child.attributes].forEach((attribute) => {
      if (!["class", "title", "aria-label", "aria-hidden"].includes(attribute.name))
        child.removeAttribute(attribute.name)
    })
  })
  element.replaceChildren(template.content)
}
